import { Form } from 'antd';
import { getRules, getForm } from './util';
import { fieldTypeMap } from '@/utils/constants';

// 下拉 / 树选择类控件（含 en_name=org_id 的预置组织字段），选中即是一次完整的值提交，
// 需要在 onChange 时重新校验。antd 默认的 validateTrigger 就是 onChange，
// 但使用方的 Form 上若设置了 validateTrigger="onBlur"（如 InformationModal），选择后不会触发重校验，
// 会出现「值已有效、必填提示却残留，再次提交反而能通过」的问题，故此处显式改回 onChange。
// 注意：级联(field_type=4)不在此处处理——它走 getForm 且不套外层 Form.Item，
// 由 BaseCascader 自带 Form.Item，需在该组件内单独设置。
const isSelectControl = (props) =>
        props.field_type === fieldTypeMap.SELECTED ||
        props.field_type === fieldTypeMap.SELECTEDTREE ||
        (props.field_type === fieldTypeMap.TEXT && props.en_name === 'org_id'),
    //form.item里面不能存在其他标签，所以用函数代替标签写法
    DynamicForm = (props) => {
        return props.field_type === fieldTypeMap.DATE ||
            props.field_type === fieldTypeMap.FILE ||
            props.field_type === 4 ||
            props.field_type === 3 ? (
            getForm(props)
        ) : (
            <Form.Item
                key={props.field_id}
                label={props.label === undefined ? props.name : props.label}
                name={props.en_name}
                rules={getRules(props)}
                validateTrigger={isSelectControl(props) ? 'onChange' : undefined}
            >
                {getForm(props)}
            </Form.Item>
        );
    };
export default DynamicForm;
